import React from 'react';
import { Bar } from 'react-chartjs-2';
import { ConsumoSemanalItem } from 'src/controllers/Dashboard/FleetAdmin/DashboardCombustivelController';

const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

interface Props {
    consumoSemanal: ConsumoSemanalItem[];
}

const ConsumoSemanalChart: React.FC<Props> = ({ consumoSemanal }) => {
    const now = new Date();

    // Monta array fixo dos últimos 7 dias
    const ultimos7: { label: string; litros: number; isHoje: boolean }[] = [];
    for (let i = 6; i >= 0; i--) {
        const d = new Date(now);
        d.setDate(d.getDate() - i);
        const dia = d.getDate();
        const mes = d.getMonth() + 1;
        const ano = d.getFullYear();
        const found = consumoSemanal.find(
            r => r.dia === dia && r.mes === mes && r.ano === ano
        );
        ultimos7.push({
            label: DIAS_SEMANA[d.getDay()],
            litros: found ? found.litros : 0,
            isHoje: i === 0,
        });
    }

    const maxLitros = Math.max(...ultimos7.map(d => d.litros), 1);

    const chartData = {
        labels: ultimos7.map(d => d.label),
        datasets: [
            {
                label: 'Litros',
                data: ultimos7.map(d => d.litros),
                backgroundColor: ultimos7.map(d => d.isHoje ? '#22c55e' : '#3b82f6'),
                borderRadius: 8,
                borderSkipped: false,
            },
        ],
    };

    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: {
                callbacks: {
                    label: (ctx: any) => ` ${ctx.parsed.y.toLocaleString('pt-BR')} L`,
                },
            },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { color: '#a0aec0', font: { size: 12 } },
            },
            y: {
                display: false,
                max: maxLitros * 1.2,
            },
        },
    };

    const todayLitros = ultimos7[6].litros;

    return (
        <div style={{
            background: '#1e1e2e',
            borderRadius: 16,
            padding: '1.2rem 1.4rem',
            marginBottom: '1.5rem',
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <span style={{ color: '#fff', fontWeight: 700, fontSize: 18 }}>Consumo semanal</span>
                <span style={{ color: '#a0aec0', fontSize: 13 }}>Litros</span>
            </div>
            {todayLitros > 0 && (
                <div style={{ textAlign: 'right', marginBottom: 4 }}>
                    <span style={{ color: '#22c55e', fontWeight: 700, fontSize: 14 }}>
                        {todayLitros.toLocaleString('pt-BR')} L
                    </span>
                </div>
            )}
            <div style={{ height: 180 }}>
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

export default ConsumoSemanalChart;
